
import { useState, useEffect, Fragment } from "react";

import Config from "../Config";

import logo from '../logo.png'
import xmenu from '../menu.png'
import xmenu_black from '../menu_black.png'
import xchange from '../change.png'
import xchange_black from '../change_black.png'
import xcalendar from '../calendar.png'
import xcalendar_black from '../calendar_black.png'
import newtab from '../newtab.png'
import newtab_black from '../newtab_black.png'


function MenuTop(props)
{

        const [tCounter, setTCounter] = useState(props.userData.max_session_sec);
        const [noticeReload, setNoticeReload] = useState(0);
        const [refreshView, setRefreshView] = useState(props.userData.refreshView);


        const showMenu = (e) => {
            props.mainView.changeMenuStatus(1);
        }
        
        const hideMenu = (e) => {
            props.mainView.changeMenuStatus(0);
        }

        const reqRefresh = () => {

      
            setTCounter( tCounter - 1 );        
            
                    var b5 = tCounter % 10;
    
    
                    if(b5 == 0  )
                    {        
                                var dt = { 
                                    'clock': tCounter,
                                    'version': Config.app_version,
                                 }
    
                
                                fetch( Config.url + '/rest_v1,refresh', {
                                    method: 'POST', 
                                    body: JSON.stringify(dt), 
                                    headers: {
                                        'Content-Type': 'text/html',
                                        'X-API-KEY': props.userData.apiKey,
                                        '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                                        '_p_dziecko_id_': props.userData.p_dziecko_id,
                                        '_sec_key_': Config.genXKey() ,
                                    }
                                })
                                .then(res => res.json() )
                                .then(res => {                                           
                                
                                    

                                    if(res.ERROR != undefined )
                                    {
                                        
                                        if(res.ERROR == 'logout' || res.ERROR == 'LOGOUT')
                                        {
                                            //props.mainView.logout();
                                            localStorage.clear();
                                            sessionStorage.clear();

                                            props.mainView.showDialog("Ups!", "Sesja została zakończona", "ok", (option)=>{

                                                document.location.href = "/?msg=logout";

                                            })
                                        }
                                    }

                                    if(res.status != null && res.status != undefined)
                                    {
    
    
                                           if(   (res.status == 'ask_reload' || res.status == 'ASK_RELOAD') && noticeReload == 1 )
                                            {
                                                //zapytaj i przeładuj..
                                                setNoticeReload(1);
                                            }
    
                                            if(res.status == 'reload' || res.status == 'RELOAD' )
                                            {
                                                window.location.reload();
                                            }
    
                                            if(res.status == 'logout' || res.status == 'LOGOUT')
                                            {
                                                 props.mainView.logout();
                                                 window.location.reload();
                                            }

                                            if(res.status == 'OK' || res.status == 'ok' )
                                            {
                                                if(props.mainView.refreshHandle != null ) props.mainView.refreshHandle();

                                                if(res.global != undefined)  //ilosc nowych dzieci w rekrutacji..
                                                {
                                                   
                                                  // var actGlobal = props.mainView.getGlobal('_x_'); 
                                                   //var isAnyNew = false;
                                                   var tmpGlobal = new Object();                                                                                                     

                                                   for (const [key, value] of Object.entries(res.global)) {                                                                                                         

                                                       var actVal = props.mainView.getGlobal(key);  
                                                       if(actVal != value)
                                                       {
                                                            tmpGlobal[key] = value;  
                                                           // isAnyNew = true;
                                                       }                                                                                                                                                                                                               
                                                    }

                                                    //if(isAnyNew)
                                                    props.mainView.setGlobal(  '_x_', tmpGlobal );
                                                }

                                                if(res.p_przedszkole_id != undefined)
                                                {
                                                          //  console.log("P.", res.p_przedszkole_id , props.userData.p_przedszkole_id);                                                                                                              

                                                            if(props.userData.p_przedszkole_id > 0 && res.p_przedszkole_id != props.userData.p_przedszkole_id )                                                            
                                                            {
                                                                props.mainView.showDialog("Potwierdź", "Placówka została zmieniona", "ok", (option)=>{
                        
                                                                            ///--------
                                                                             window.location.reload();
                                                                            //--------
                                                                    } );
                                                            }
                                                }

                                                if(res.p_dziecko_id != undefined)
                                                    {
                                                            //console.log("D.", res.p_dziecko_id, props.userData.p_dziecko_id  );

                                                            if(props.userData.p_dziecko_id > 0 && res.p_dziecko_id != props.userData.p_dziecko_id )                                                            
                                                                {
                                                                    props.mainView.showDialog("Potwierdź", "Profil dziecka został zmieniony", "ok", (option)=>{
                            
                                                                                ///--------
                                                                                 window.location.reload();
                                                                                //--------
                                                                        } );
                                                                }
                                                    }


                                                if(res.msgs != null)
                                                {
                                                    for(var xk=0; xk < res.msgs.length; xk++)
                                                    {
                                                        var mTitle = res.msgs[xk].title;
                                                        var mMsg   = res.msgs[xk].msg;

                                                        props.mainView.showDialog( mTitle ,  mMsg  ,  "ok"  ,null); 
                                                    }
                                                }

                                                if(res.platnosci != null)
                                                {
                                                    if(res.platnosci.saldo < 0 )
                                                    {
                                                        if(res.platnosci.faktury.length > 0)
                                                        {
                                                            if(!document.location.href.includes("view/pay"))
                                                                {
                                                                     props.mainView.showDialog( "Ups!", "Nie odnotowaliśmy płatności za fakturę."  , "ok" ,  (param) => {
                                                                         document.location.href="/module/home/view/pay";                       
                                                                     } );  
                                                                }
                                                        }
                                                    }
                                                  
                                                     
                                                }

                                            }


                                            if(res.status == 'VERSION' || res.status == 'version')
                                                {

                                                    var ts = new Date() / 1000;

                                                    var lastTs =  props.mainView.readFilter('version_app',  -1 );
                                                    var diffTs = 0;

                                                    if(lastTs > 0)
                                                    {
                                                        diffTs =  parseFloat( ts) -  parseFloat(lastTs) ;
                                                    }

                                                    console.log(lastTs, ts, diffTs);

                                                    if(diffTs  > 120 || diffTs == 0)
                                                    {
                                                            props.mainView.writeFilter('version_app',ts );
                                                        
                                                            props.mainView.showDialog("Potwierdź", "Panel wymaga aktualizacji. Czy chcesz teraz przeładować stronę?", "yesno", (option)=>{
                
                                                                ///--------
                                                                if(option == "yes")  window.location.reload();
                                                                //--------
                                                        } );
                                                  }


                                                }
    
                                        
                                    }
                                    
                                } )
                                .catch(err => {
                                    console.log("Err " + err);
                                });                                    
                    }//b5 = 0
    
       }


   

 
       if(window.internalID == null || window.internalID == undefined)
       {          
             window.internalID =  setInterval(reqRefresh, 1000 );
       }else
       {
           clearInterval( window.internalID );
           window.internalID =  setInterval(reqRefresh, 1000 );
       }

      

        const changeProfile = (e) => {

            let type = e.target.getAttribute("atr-type");
            let typeId = e.target.getAttribute("atr-typeid");
            let newTab = e.target.getAttribute("atr-tab");

            var nx = false;
            if(newTab != undefined && newTab != null) nx = true;

            props.mainView.changeProfile(type, typeId, nx); //dz pl + id
        }

        const goNewTab = (e) => {

              props.mainView.changeProfile('none', -1, true);  //dz pl + id
        }

        

 

        var date = new Date(0);
        if(tCounter != undefined)date.setSeconds(tCounter); 
        var timeString = date.toISOString().substring(11, 19);

        var classDef = "";
        if(tCounter < 60)
        {
            classDef = "alert";
        }


        var choiseOption = null;
        var pakiet = null;


        var pSeleted = "";
        var pSeletedId = -1;
        var pPFirmaSelectedId = -1;



        if(props.userData.type == 'RODZIC')
        {

        }else
        {
     

            for(var pi =0; pi<props.userData.pl.length; pi++ )
            {
                if(props.userData.pl[pi]['id']  == props.userData.p_przedszkole_id)
                {

                    var xnazwa = props.userData.pl[pi]['nazwa'];

                    if(xnazwa.length > 20) xnazwa = xnazwa.substring(0,20) + "...";

                    //pSeleted =  xnazwa+ ", " + props.userData.pl[pi]['ulica']  + "( ID: "+props.userData.pl[pi]['id'] +")";
                    pSeleted =  xnazwa + " " + "(ID: "+props.userData.pl[pi]['id'] +")";
                    pSeletedId = props.userData.pl[pi]['id'];
                    pPFirmaSelectedId = props.userData.pl[pi]['p_firma_id'];
                    pakiet = props.userData.pl[pi]['pakiet']  ;

                    
                }
            }

            

            choiseOption =    <div className="mtop_item popup ">
                
                    {pSeleted}  

                    <div className="windows_popup">                         
                         <div className="windows_view">

                                    <div className="pl_item">
                                        <span className="link_color"  module="home" view="new" id="" onClick={props.mainView.quickGo} >nowa placówka (+)</span>
                                    </div>
                                
                                    {
                                        props.userData.pl.map( (item, ix) => {

                                            
                                            var xnazwa = item.nazwa;

                                           // if(xnazwa.length > 15) xnazwa = xnazwa.substring(0,15) + "...";


                                            if(item.id == pSeletedId)
                                            {
                                           

                                                return (
                                                    <div className="pl_item pl_active" key={"p_" +ix }>
                                                        <div className="pl_img">
                                                            <img src={ "data:image/jpeg;base64, " + item.b64}   title={item.ulica + " " + item.miasto} />
                                                        </div>
                                                        <div className="pl_title" title={item.ulica + " " + item.miasto} >
                                                            {xnazwa} <sup>[{item.id}]</sup>,
                                                            <br/>
                                                            <span className="pl_address">ul. {item.ulica + " " + item.miasto}</span>
                                                            <br/>
                                                            <span className="pl_link" module="home" view="info" id="" onClick={props.mainView.quickGo}  >
                                                                {props.userData.dic.mdata} 
                                                            </span>
                                                            | 
                                                            <span className="pl_link"  module="home" view="director" id="" onClick={props.mainView.quickGo} >
                                                                {props.userData.dic.mdirectors} 
                                                            </span>
                                                            | 
                                                            <span className="pl_link" module="home" view="freedays" id="" onClick={props.mainView.quickGo} >
                                                                {props.userData.dic.mfreedays} 
                                                            </span>
                                                            |
                                                            <span className="pl_link" module="home" view="reader" id="" onClick={props.mainView.quickGo}>
                                                                {props.userData.dic.mreader} 
                                                            </span>
                                                            | 
                                                            <span className="pl_link" module="home" view="support" id="" onClick={props.mainView.quickGo}>
                                                                {props.userData.dic.msupport} 
                                                            </span>
                                                            | 
                                                            <span className="pl_link" module="home" view="pay" id="" onClick={props.mainView.quickGo} >
                                                                {props.userData.dic.minvoice} 
                                                            </span>                                                            
                                                           
                                                        </div>                                                   
                                                </div>
                                                )  
                                            }

                                            return (
                                                <div className="pl_item" key={"p_" +ix }>
                                                    <div className="pl_img">
                                                        <img src={ "data:image/jpeg;base64, " + item.b64} className="pl_link" atr-type={"pl"} atr-typeid={item.id} onClick={changeProfile} title={item.ulica + " " + item.miasto}  />
                                                    </div>
                                                    <div className="pl_title" title={item.ulica + " " + item.miasto}>
                                                        {xnazwa} <sup>[{item.id}]</sup>
                                                        <br/>
                                                        <span className="pl_address">ul. {item.ulica + " " + item.miasto}</span>
                                                        <br/>
                                                        <span className="pl_link" atr-type={"pl"} atr-typeid={item.id} onClick={changeProfile} >
                                                            pokaż tutaj
                                                        </span>
                                                        &nbsp;  &nbsp;  lub &nbsp; &nbsp; 
                                                        <span className="pl_link" atr-type={"pl"} atr-typeid={item.id} atr-tab="true" onClick={changeProfile} >
                                                            pokaż w nowej karcie
                                                        </span>

                                                        
                                                    </div>                                                   
                                                </div>
                                            )


                                        } )
                                    }

                                <div className="normal_hide pop_up_btn">
                                     <a href="/" className="btn"  >Zamknij</a>
                                </div> 
                                    
                         </div>                   
                    </div>


                    &nbsp; <img src={newtab}   className="link_normal img_white" title="Otwórz placówkę w nowej karcie"   onClick={goNewTab} />  <img src={newtab_black}   className="link_normal img_black" title="Otwórz placówkę w nowej karcie"   onClick={goNewTab} /> &nbsp; 
                </div>
        }



        if(refreshView != props.userData.refreshView)
        {
            //props.userData.max_session_sec
            
            setRefreshView(props.userData.refreshView);
            setTCounter(props.userData.max_session_sec);
        }
        
      
       
        useEffect(() => {

                   //console.log("useEff");
                   setTimeout( () => {

                    
                        var script = document.createElement('script');
                        script.type = 'text/javascript';
                        script.src = 'https://faktury.progressplus.pl/api,rodojs';    

                        document.head.appendChild(script);

                   } ,2000);

          },  [] );


        return (
            <div className="menu_top" >       
                
             


                &nbsp;   
                {
                    props.mainView.menuSelected != "men" &&
                    <Fragment>


                        {
                            props.mainView.menuVisible == 0 &&
                            <div className="menu_show_btn link_normal mobile_hide_now " onClick={showMenu}>
                                <img src={xmenu} className="img_white" />
                                <img src={xmenu_black} className="img_black" />
                                </div>
                        }

                        {
                            props.mainView.menuVisible == 1 &&
                            <div className="menu_show_btn link_normal mobile_hide_now" onClick={hideMenu}  >
                                <img src={xmenu} className="img_white" />
                                <img src={xmenu_black} className="img_black" />
                                </div>
                        }



                        <div className="menu_show_btn2 link_normal link_men nohide_mobile"  module="men" view="start" id="xt_men" onClick={props.mainView.quickGo } >&nbsp;<span className="men_btn"></span>&nbsp;idź do: e-dziennika&nbsp;</div>                           
                        <div className="menu_show_btn2 link_normal"  module="calc" view="transfer" id="-20" onClick={props.mainView.quickGo}  ><span className="plus_btn"></span> Dodaj wpłatę</div>
                        <div className="menu_show_btn2 link_normal"  module="calc" view="transfer" id="-30" onClick={props.mainView.quickGo} ><span className="plus_btn"></span> Importuj przelewy</div>                                   

                      
                        {
                            props.userData.all != undefined && props.userData.all != null && props.userData.all.phone_p != undefined &&
                            <span className="menu_show_btn2 link_normal link_men nohide_mobile">Tel. hasło klienta:  <b>{props.userData.all.phone_p} </b> </span>
                        }
                    </Fragment>
                }
             
                &nbsp;   
                {
                    props.mainView.menuSelected == "men" &&
                    <Fragment>
                        <div className="menu_show_btn2 link_normal link_men nohide_mobile"  module="home" view="start" id="xt_xt" onClick={props.mainView.quickGo } >&nbsp;<span className="men_btn"></span>&nbsp;wróć do: eLizaka&nbsp;</div>                                                           
                    </Fragment>
                }


                {choiseOption} 



                <div className="mtop_item mobile_hide link_normal" title="Aktywny pakiet lub umowa" module="home" view="pay" id="" onClick={props.mainView.quickGo} >{pakiet}  <img src={xcalendar} className="img_white"/> <img src={xcalendar_black} className="img_black" /> </div>


                <div className="mtop_item mobile_hide" title="Koniec sesji za">{props.userData.dic.toend}: <span className={classDef}   >{timeString} </span></div>

               
                <div className="mtop_item popup mobile_hide" title="Wyloguj z systemu">
                &nbsp; &nbsp;  {props.userData.name}   &nbsp; &nbsp;
                      <div className="windows_popup">                         
                         <div className="windows_view">
                                               <div className="pl_item">
                                                    <div className="pl_img pl_link " onClick={props.mainView.logout}>
                                                          {props.userData.dic.logout}
                                                    </div>                                                                                                      
                                                </div>

                                                <div className="pl_item">
                                                    <div className="pl_img pl_link " module="home" view="account" id="" onClick={props.mainView.quickGo}>
                                                         {props.userData.dic.account}
                                                    </div>                                                                                                      
                                                </div>
                         </div>
                      </div>
                </div>

                


                {
                    pPFirmaSelectedId > 0 &&
                    <div data-client={pPFirmaSelectedId} data-widget="1"  data-user={props.userData.name + " " + props.userData.last_name }  view="MenuTop" data-color="#eee" data-color-br="ccc" id="rodo_plugin"></div>
                }    
               

            </div>
        )
}


export default MenuTop;